import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import './OnboardingTips.css';

function OnboardingTips() {
  const { showOnboarding, setShowOnboarding, user } = useAuth();
  const { t } = useTranslation();
  const [currentTip, setCurrentTip] = useState(0);

  const tips = [
    {
      icon: '🔍',
      title: t('onboardingSearchTitle'),
      description: t('onboardingSearchSubtitle')
    },
    {
      icon: '📦',
      title: t('onboardingSellTitle'),
      description: t('onboardingSellSubtitle')
    }
  ];

  if (!showOnboarding) return null;

  const handleNext = () => {
    if (currentTip < tips.length - 1) {
      setCurrentTip(currentTip + 1);
    } else {
      setShowOnboarding(false);
    }
  };

  const handleSkip = () => {
    setShowOnboarding(false);
  };

  return (
    <div className="onboarding-overlay">
      <div className="onboarding-popup">
        <div className="onboarding-content">
          <div className="tip-icon">{tips[currentTip].icon}</div>
          <h3 className="tip-title">{tips[currentTip].title}</h3>
          <p className="tip-description">{tips[currentTip].description}</p>
          
          <div className="tip-dots">
            {tips.map((_, idx) => (
              <div
                key={idx}
                className={`tip-dot ${idx === currentTip ? 'tip-dot-active' : ''}`}
              />
            ))}
          </div>

          <div className="tip-buttons">
            <button
              onClick={handleSkip}
              className="btn btn-ghost"
              data-testid="skip-tips"
            >
              {t('onboardingSkip')}
            </button>
            <button
              onClick={handleNext}
              className="btn btn-primary"
              data-testid="next-tip"
            >
              {currentTip < tips.length - 1 ? t('onboardingNext') : t('signupSuccessCta')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingTips;
